import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import { useParams } from "react-router-dom";

import ReactSelect from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import { SimsoAction } from 'src/actions/simso.action';

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";
import { LocationAction } from 'src/actions/location.action';

const TheHomepageSimsoOne = ({ product }) => {
    const dispatch = useDispatch()
    const { itemId } = useParams();
    const { homepageSimsoSelected } = useSelector(state => state.simso)
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [ynghiasimContent, setYnghiasimContent] = useState("");
    const [so_dien_thoai, setSoDienThoai] = useState("");
    const [so_dien_thoai1, setSoDienThoai1] = useState("");
    const [loai_sim_text, setLoaiSimText] = useState("Sim Phong Thủy");
    const [gia_khach_hang, setGiaKhachHang] = useState("");
    const [gia_khach_hang_khuyen_mai, setGiaKhachHangKhuyenMai] = useState("");
    const [tinh_trang, setTinhTrang] = useState("");
    const [tinh_trang_color, setTinhTrangColor] = useState("");
    const [nha_mang, setNhaMang] = useState("");
    const [nha_mang_1, setNhaMang1] = useState("");
    const [nha_mang_2, setNhaMang2] = useState("");
    const [loai_sim, setLoaiSim] = useState("");
    const [loai_thue_bao, setLoaiThueBao] = useState("");
    const { isLoading } = useSelector(state => state.app);
    const [isLoading1, setIsLoading] = useState("0");
    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ;

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        province: "-99",
        province_name: "",
        district: "-99",
        district_name: "",
        ward: "-99",
        ward_name: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        itemId,
    });

    useEffect(() => {
        console.log(itemId);
        dispatch(SimsoAction.homepageFindOne(itemId));
    }, [])

    useEffect(() => {
        console.log(homepageSimsoSelected);

        setSoDienThoai('');
        setSoDienThoai1('');
        setLoaiSimText('Sim Phong Thủy')
        setGiaKhachHang('');
        setGiaKhachHangKhuyenMai('');
        setTinhTrang('');
        setTinhTrangColor('');
        setNhaMang('');
        setNhaMang1('');
        setNhaMang2('');
        setLoaiSim('');
        setLoaiThueBao('');

        if (homepageSimsoSelected && homepageSimsoSelected.simso && homepageSimsoSelected.getSimAnalysis) {
            let simso = homepageSimsoSelected.simso;

            setSoDienThoai(simso.so_dien_thoai_co_dau_cham ? simso.so_dien_thoai_co_dau_cham : '');

            setSoDienThoai1(simso.so_dien_thoai ? simso.so_dien_thoai : '');
            
            setGiaKhachHang(simso.gia_khach_hang ? Number(simso.gia_khach_hang) : '0');

            setGiaKhachHangKhuyenMai(simso.gia_khach_hang_khuyen_mai ? Number(simso.gia_khach_hang_khuyen_mai) : '0');
            
            setNhaMang(simso.nha_mang == "MOBIFONE" ? iconMobifone : (simso.nha_mang == "VINAPHONE" ? iconVinaphone : iconViettel))
            setNhaMang1(simso.nha_mang)
            setNhaMang2(simso.nha_mang == "MOBIFONE" ? "-160px 3px" : (simso.nha_mang == "VINAPHONE" ? "-80px 3px" : "0px 3px"))
            
            setTinhTrang(simso.trang_thai == 'con_sim' ? 'Còn sim' : (simso.trang_thai == 'giu_so' ? 'Giữ số' : 'Đã bán'))
            setTinhTrangColor(simso.trang_thai == 'con_sim' ? 'green' : (simso.trang_thai == 'giu_so' ? 'orange' : 'red'))

            setLoaiThueBao(simso.number_type == '1' ? 'Trả trước' : (simso.number_type == '2' ? 'Trả sau' : ''))

            if (simso.types && Object.keys(simso.types).length > 0) {
                let inputLoaiSo = [];

                Object.entries(simso.types).forEach(([key, value]) => {
                    if ([value.loai_sim] in danhSachLoaiSim) {
                        inputLoaiSo.push(danhSachLoaiSim[value.loai_sim]);
                        if (loai_sim_text == 'Sim Phong Thủy') setLoaiSimText(danhSachLoaiSim[value.loai_sim])
                    }
                });

                setLoaiSim(inputLoaiSo.join(', '));
            }

            async function fetchData() {
                try {
                    let getProvinces = await dispatch(LocationAction.getProvinces());
                    console.log(getProvinces);
                    setProvinces(getProvinces);
                } catch (error) {
                    console.error(error);
                }
            }

            fetchData();
        }
    }, [homepageSimsoSelected])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    ward: "-99", 
                    ward_name: "", 
                });
                setWards([]);
                let getWards = await dispatch(LocationAction.getWardsByDistrict(formData.district));
                console.log(getWards);
                setWards(getWards);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province, formData.district])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    district: "-99",
                    district_name: "", 
                });
                setDistricts([]);
                let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(formData.province));
                console.log(getDistricts);
                setDistricts(getDistricts);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (key, value, key1 = null, value1 = null) => {
        if (key1 && value1) {
            setFormData({ 
                ...formData, 
                [key]: value,
                [key1]: value1,
            });
        } else {
            setFormData({ 
                ...formData, 
                [key]: value 
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(SimsoAction.sendOrder(formData));
    };

    return (<>
        <Helmet>
            <title>Sim số {so_dien_thoai1} - {loai_sim_text} {so_dien_thoai1} | Kho số - Di Dong Telecom</title>
            <meta name="description" content={`${so_dien_thoai1} thuộc nhà mạng ${nha_mang_1} với đầu số ${so_dien_thoai1.slice(0, 4)} và loại ${loai_sim_text} với đuôi số ${so_dien_thoai1.slice(-4)} có giá bán tại khoso.didongtelecom.vn là ${gia_khach_hang_khuyen_mai > 0 && gia_khach_hang_khuyen_mai < gia_khach_hang ? numeral(gia_khach_hang_khuyen_mai).format("0,0") : numeral(gia_khach_hang).format("0,0")} ₫. Đăng ký chính chủ và hỗ trợ giao sim toàn quốc`} />
        </Helmet>

        {isLoading && <div className='loading'></div>}
        
        {!isLoading && homepageSimsoSelected && homepageSimsoSelected.simso && <div style={{ margin: "0 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)" }}>
            {so_dien_thoai && <div className='simso-one-detail-container' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 0 0 0", background: "transparent", borderRadius: "10px" }}>
                <img className='simso-one-img' src={`/api/v1/simso/getSimkitImage/${homepageSimsoSelected && homepageSimsoSelected.simso ? homepageSimsoSelected.simso.id : ''}`} alt={so_dien_thoai} style={{gap: "10px", width: "50%"}}/>
                <div className='simso-one-detail' style={{ display: "grid", gridTemplateColumns: "100px auto", gap: "5px 10px", width: "50%", padding: "0 0 0 20px", alignItems: 'center' }}>
                    <strong>Số sim:</strong> <span className='so-sim' style={{color: '#037319', fontSize: '24px', fontWeight: 'bold'}}>{so_dien_thoai}</span>
                    <strong>Giá:</strong> <span className='price' style={{color: 'var(--main-color)', fontWeight: 'bold'}}>
                        {
                            gia_khach_hang_khuyen_mai > 0 && gia_khach_hang_khuyen_mai < gia_khach_hang ? (
                                <div>
                                    <span style={{ color: "red", fontWeight: "bold" }}>{numeral(gia_khach_hang_khuyen_mai).format("0,0")}₫</span>
                                    <br></br>
                                    <span className='price-old' style={{ textDecoration: "line-through", color: "#888" }}>{numeral(gia_khach_hang).format("0,0")}₫</span>
                                </div>
                            ) : (
                                <div>
                                    <span style={{ fontWeight: "bold" }}>{numeral(gia_khach_hang).format("0,0")}₫</span>
                                </div>
                            )
                        }
                    </span>
                    <strong>Nhà mạng:</strong> 
                    <span style={{
                        backgroundImage: `url(${logoNhaMang})`,
                        backgroundPosition: nha_mang_2,
                        backgroundSize: "cover",
                        display: "inline-block",
                        width: 80,
                        height: 35
                    }}></span>
                    <strong>Thuê bao:</strong> <span>{loai_thue_bao}</span>
                    <strong>Tình trạng:</strong> <span style={{ color: tinh_trang_color }}>{tinh_trang}</span>
                    <strong>Loại sim:</strong> <span>{loai_sim}</span>
                </div>
            </div>}
        </div>}

        {!isLoading && homepageSimsoSelected && homepageSimsoSelected.simso && <div className='simso-one-ynghiasim' style={{ 
            margin: "10px 0", 
            padding: "20px", 
            borderRadius: "10px", 
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", 
            background: "var(--background-color)" 
        }}>
            <div className='ynghiasim-content' dangerouslySetInnerHTML={{ __html: homepageSimsoSelected && homepageSimsoSelected.getSimAnalysis && homepageSimsoSelected.getSimAnalysis.content }} />
        </div>}
            
        {!isLoading && homepageSimsoSelected && homepageSimsoSelected.simso && homepageSimsoSelected.simso.trang_thai == 'con_sim' && <div style={{ margin: "0 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)" }}>
            <div style={{color: '#FF0000', fontSize: '24px', fontWeight: 'bold', padding: "0 0 20px 0"}}>THÔNG TIN ĐẶT HÀNG</div>
            <form className='form-dat-hang' onSubmit={handleSubmit} style={{ display: "grid", gap: "15px", padding: "0" }}>
                <div>
                    <label>Họ và tên <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                </div>
                <div>
                    <label>Số điện thoại <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                </div>
                {/* <div>
                    <label>Email <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                </div> */}
                <div>
                    <label>Tỉnh/thành:</label>
                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                        <ReactSelect
                            classNamePrefix="nt-select"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({
                                    ...base,
                                    zIndex: 999999,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    height: 37,
                                }),
                                option: (provided) => ({
                                    ...provided,
                                }),
                            }}
                            options={[
                                { code: '-99', name: 'Chọn tỉnh/thành' },
                                ...provinces
                            ]}
                            getOptionLabel={(item) => `${item.name}`}
                            placeholder={formData.province_name || "Chọn tỉnh/thành..."}
                            components={{
                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                IndicatorSeparator: null,
                            }}
                            value={formData.province || null}
                            onChange={(newValue) => {
                                handleChange1('province', newValue.code, 'province_name', newValue.name);
                            }}
                            isSearchable
                        />
                    </div>
                </div>
                <div>
                    <label>Quận/huyện:</label>
                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                        <ReactSelect
                            classNamePrefix="nt-select"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({
                                    ...base,
                                    zIndex: 999999,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    height: 37,
                                }),
                                option: (provided) => ({
                                    ...provided,
                                }),
                            }}
                            options={[
                                { code: '-99', name: 'Chọn quận/huyện' },
                                ...districts
                            ]}
                            getOptionLabel={(item) => `${item.name}`}
                            placeholder={formData.district_name || "Chọn quận/huyện..."}
                            components={{
                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                IndicatorSeparator: null,
                            }}
                            value={formData.district || null}
                            onChange={(newValue) => {
                                handleChange1('district', newValue.code, 'district_name', newValue.name);
                            }}
                            isSearchable
                        />
                    </div>
                </div>
                <div>
                    <label>Phường/xã:</label>
                    <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                        <ReactSelect
                            classNamePrefix="nt-select"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({
                                    ...base,
                                    zIndex: 999999,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    height: 37,
                                }),
                                option: (provided) => ({
                                    ...provided,
                                }),
                            }}
                            options={[
                                { code: '-99', name: 'Chọn phường/xã' },
                                ...wards
                            ]}
                            getOptionLabel={(item) => `${item.name}`}
                            placeholder={formData.ward_name || "Chọn phường/xã..."}
                            components={{
                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                IndicatorSeparator: null,
                            }}
                            value={formData.ward || null}
                            onChange={(newValue) => {
                                handleChange1('ward', newValue.code, 'ward_name', newValue.name);
                            }}
                            isSearchable
                        />
                    </div>
                </div>
                <div>
                    <label>Địa chỉ chi tiết <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                </div>
                <div>
                    <label>Ghi chú (nếu có):</label>
                    <input type="text" name="note" value={formData.note} onChange={handleChange} style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                </div>
                <div>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <label>
                            <input type="radio" name="paymentMethod" value="cod" checked={formData.paymentMethod === "cod"} onChange={handleChange} /> COD
                        </label>
                        <label>
                            <input type="radio" name="paymentMethod" value="online" checked={formData.paymentMethod === "online"} onChange={handleChange} /> Chuyển khoản
                        </label>
                    </div>
                </div>
                <button type="submit" style={{ marginTop: "10px", padding: "10px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "bold", transition: "0.3s" }}
                    onMouseEnter={(e) => e.target.style.background = "var(--main-color)"}
                    onMouseLeave={(e) => e.target.style.background = "var(--main-color)"}>
                    Đặt hàng
                </button>
            </form>
        </div>}
    </>);
};

export default TheHomepageSimsoOne;